import React from 'react'
import PropTypes from 'prop-types'
import {
  Bag,
  Beach,
  Cars,
  Coupon,
  Cruises,
  Discount,
  Document,
  Email,
  Flights,
  Globe,
  Gps,
  Help,
  Hotels,
  InformationOutline,
  Logout,
  Restaurant,
} from 'pcln-icons'

const IconMap = {
  Bag: Bag,
  Beach: Beach,
  Cars: Cars,
  Coupon: Coupon,
  Cruises: Cruises,
  Discount: Discount,
  Document: Document,
  Email: Email,
  Flights: Flights,
  Globe: Globe,
  Gps: Gps,
  Help: Help,
  Hotels: Hotels,
  InformationOutline: InformationOutline,
  Logout: Logout,
  Restaurant: Restaurant,
}

const IconSet = ({ iconName, ...props }) => {
  const Icon = IconMap[iconName]

  return Icon ? <Icon {...props} /> : null
}

IconSet.propTypes = {
  iconName: PropTypes.string,
}

export default IconSet
